export const dedupe = <T>(array: T[]) => array.filter((value, index, arr) => arr.indexOf(value) === index);

export const deepMergeArrays = <T>(firstArr: T[], secondArr: T[], key: string) => {
    const mergedArray = [...secondArr, ...firstArr];

    const set = new Set();
    const unionArray = mergedArray.filter((item: { [key: string]: any }) => {
        if (!set.has(item[key])) {
            set.add(item[key]);
            return true;
        }
        return false;
    }, set);

    return unionArray;
};
